import api from "@/plugins/api";
export const contactSocialProfileApi = {
    /** Returns the new profile's ID (BFF returns ApiResponse<Guid>, interceptor unwraps to string). */
    create(contactId, data) {
        return api
            .post(`/contacts/${contactId}/social-profiles`, { socialNetworkId: data.networkId, value: data.value, label: data.label }, { unwrapEnvelope: true })
            .then((r) => r.data);
    },
    update(contactId, profileId, data) {
        return api.put(`/contacts/${contactId}/social-profiles/${profileId}`, { socialNetworkId: data.networkId, value: data.value, label: data.label }, { unwrapEnvelope: true });
    },
    delete(contactId, profileId) {
        return api.delete(`/contacts/${contactId}/social-profiles/${profileId}`, { unwrapEnvelope: true });
    },
};
